<div class="d-flex align-items-center justify-content-end cgap-05 text-nowrap">
    <ng-content select="[before-flag]"></ng-content>
    <img [width]="size" [height]="size" [src]="imageUrl" [alt]="lang" (load)="imageLoaded=true"
         (error)="imageLoaded=false" [style.display]="imageLoaded ? 'block' : 'none'">
    <ng-content select="[after-flag]"></ng-content>
</div>